import login from './login'
import register from './register'
import modify from './modify'
import accountInfo from './accountInfo'
import order from './order'
import invoice from './invoice'
export default {
  namespaced: true,
  modules: {
    login,
    register,
    modify,
    accountInfo,
    order,
    invoice
  }
}
